import Header from "./components/header";
import StakeBanner from "./components/stakebanner";
import StakeHeader from "./components/stakeheader";
import StakeStats from "./components/stakestats";
import StakeBody from "./components/stakebody";
import Footer from "./components/footer";
import "./styles/App.css";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./App.css";

import {configVars} from "./config/config.ts";
import React, {useEffect, useState} from "react";
import {ethers, providers} from "ethers";
import Web3Modal from "web3modal";
import ClipLoader from "react-spinners/ClipLoader";
import supabase from './config/supabaseClient.js';
import {providerOptions} from "./config/providerOptions";

require("dotenv").config({path: ".env"});

function addTokenAddressToContractAddresses(nfts) {
    let tokenIds = [];
    let contractAddresses = [];
    let nftTotal = 0;

    if (nfts.length > 25) {
        nftTotal = 25;
    } else {
        nftTotal = nfts.length;
    }

    for (let i = 0; i < nftTotal; i++) {
        contractAddresses.push(nfts[i].tokenAddress.toLowerCase());
        tokenIds.push(nfts[i].tokenId);
    }
    return {tokenIds, contractAddresses};
}

function App() {

    const [loading, setLoading] = useState(false);
    const [availableNFTs, setAvailableNFTs] = useState("");
    const [allNFTs, setAllNFTs] = useState([]);
    const [walletAddress, setAddress] = useState("");
    const [signer, setSigner] = useState("");
    const [claimableReward, setClaimableReward] = useState("");
    const [trpzBalance, setTrpzBalance] = useState("");
    const [library, setLibrary] = useState("");
    const [totalReward, setTotalReward] = useState(0);

    const [stakedNFTCount, setStakedNFTCount] = useState([]);
    const [stakedNFTs, setStakedNFTs] = useState([]);
    const [NFTObjects, setNFTObjects] = useState([]);
    const [disabled, setDisabled] = useState(true);

    const [stakedNftDetails, setStakedNftDetails] = useState([]);

    const web3Modal = new Web3Modal({
        network: "cronos",
        providerOptions,
    });

    useEffect(() => {
        async function getBasics() {
            if (walletAddress) {
                await getTrpzBalance();
                await getStakedIds(walletAddress);
            }
        }

        getBasics();
    }, [walletAddress]);

    useEffect(() => {
        async function getAvailable() {
            await getAllNFTInfo();
            await getClaimableReward();
            setLoading(false);
        }

        getAvailable();
    }, [stakedNftDetails]);

    async function connectWallet() {
        try {
            web3Modal.clearCachedProvider();
            const provider = await web3Modal.connect();
            const library = new providers.Web3Provider(provider);
            const {chainId} = await library.getNetwork();
            if (chainId !== 25) {
                toast("Use Cronos to connect", {
                    className: 'custom-toast'
                });
            }
            const accounts = await library.listAccounts();
            const signer = library.getSigner();
            setSigner(signer);
            setLibrary(library);
            setAddress(accounts[0]);
        } catch (error) {
            console.log(error);
        }
    }

    async function disconnectWallet() {
        web3Modal.clearCachedProvider();
        setAddress("");
        setTrpzBalance(0);
        setClaimableReward(0);
        setAvailableNFTs(0);
        setTotalReward(0);
        setStakedNFTCount(0);
        window.location.reload();
    }

    async function getTrpzBalance() {
        if (walletAddress === "") return;
        const trpzToken = new ethers.Contract(
            configVars.erc20.trpzToken,
            configVars.abi.trpzToken,
            library
        );
        const balance = await trpzToken.balanceOf(walletAddress);
        setTrpzBalance(balance.toNumber());
    }

    async function getStakedIds(walletAddress) {
        const {data, error} = await supabase
            .from('staking_info')
            .select('nft_smart_contract, nft_id')
            .eq('staker', walletAddress);

        if (error) {
            console.error("Error fetching staked NFTs details: ", error)
            return [];
        }
        try {
            setStakedNftDetails(data.map(item => [item.nft_id, item.nft_smart_contract]));
            setLoading(true);
        } catch (error) {
            console.error("Error fetching staked ids");
            setLoading(true);
        }
    }

    function chunkArray(array, chunkSize) {
        const chunks = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            chunks.push(array.slice(i, i + chunkSize));
        }
        return chunks;
    }

    const chunkSize = 60;
    const stakedNftChunks = chunkArray(stakedNftDetails, chunkSize);
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    async function getAllNFTInfo() {
        if (walletAddress === "") return;

        try {
            const stakedObjects = [];
            const availableObjects = [];
            let rewardSum = 0;

            // Get staked NFTs
            for (const chunk of stakedNftChunks) {
                await Promise.all(chunk.map(async ([tokenId, contractAddress]) => {
                    try {
                        const options = {
                            method: "GET",
                            headers: {accept: "application/json"},
                        };
                        const response = await fetch(
                            `https://api.ebisusbay.com/nft?collection=${contractAddress}&tokenId=${tokenId.toString()}`,
                            options
                        );
                        const responseData = await response.json();
                        const stakedNft = {
                            name: responseData.collection.name,
                            owner: responseData.nft.owner.toLowerCase(),
                            tokenId: tokenId.toString(),
                            tokenAddress: contractAddress.toLowerCase(),
                            tokenImage: responseData.nft.image,
                            rank: responseData.nft.rank,
                            dailyReward: configVars.rewardArray[contractAddress.toLowerCase()],
                            stakingId: tokenId.toString(),
                        };
                        stakedObjects.push(stakedNft);
                        rewardSum += stakedNft.dailyReward;
                    } catch (error) {
                        console.error(`Error processing tokenId: ${tokenId}`, error);
                    }
                }));

                if (stakedNftChunks.indexOf(chunk) !== stakedNftChunks.length - 1) {
                    await delay(2000); // 2 seconds
                }
                setStakedNFTs(stakedObjects);
                setStakedNFTCount(stakedObjects.length);
                setTotalReward(rewardSum);
            }

            // Get available NFTs
            const whitelistArray = configVars.whitelist;
            const addressString = whitelistArray.join(",");
            const options = {method: "GET", headers: {accept: "application/json"}};
            let currentPage = 1;
            let totalPages = 1;

            while (currentPage <= totalPages) {
                const response = await fetch(
                    `https://api.ebisusbay.com/v2/wallets?wallet=${walletAddress}&collection=${addressString}&pageSize=100&page=${currentPage}`,
                    options
                );
                const responseData = await response.json();

                if (!responseData.nfts) {
                    console.error("Unexpected API response:", responseData);
                    break;
                }

                totalPages = responseData.totalPages;

                await Promise.all(
                    responseData.nfts.map(async (nft) => {
                        try {
                            const availableNft = {
                                name: nft.collectionName,
                                owner: nft.owner.toLowerCase(),
                                tokenId: nft.nftId,
                                tokenAddress: nft.nftAddress.toLowerCase(),
                                tokenURI: nft.token_uri,
                                rank: nft.rank,
                                tokenImage: nft.image,
                                dailyReward: configVars.rewardArray[nft.nftAddress.toLowerCase()],
                            };
                            availableObjects.push(availableNft);
                        } catch (error) {
                            console.error(`Error processing nftId: ${nft.nftId}`, error);
                        }
                    })
                );

                if (currentPage !== totalPages) {
                    await delay(2000); // 2 seconds delay between pages (not between chunks)
                }

                currentPage++;
            }
            setNFTObjects(availableObjects);
            setAvailableNFTs(availableObjects.length);

            // Combine staked and available NFTs
            const allNFTs = [...stakedObjects, ...availableObjects];
            setAllNFTs(allNFTs);

            return {
                stakedNFTs: stakedObjects,
                availableNFTs: availableObjects,
                totalReward: rewardSum,
                allNFTs: allNFTs,
            };
        } catch (error) {
            toast("An error occurred, please reload the page", {
                className: 'custom-toast',
            });
            console.error(error);
        }
    }

    async function getOwnerReward(trpzStake, walletAddress) {
        try {
            const ownerReward = await trpzStake.ownerRewards(walletAddress);
            return ownerReward.toNumber();
        } catch (error) {
            console.error("Error fetching owner rewards:", error);
            throw error; // Re-throw the error to handle it elsewhere if needed
        }
    }

    async function getPreviewRewards(trpzStake, walletAddress) {
        try {
            const previewRewards = await trpzStake.previewRewards(walletAddress);
            return previewRewards[0].toNumber();
        } catch (error) {
            console.error("Error fetching preview rewards:", error);
            throw error; // Re-throw the error to handle it elsewhere if needed
        }
    }

    async function getClaimableReward() {
        if (walletAddress === "") return;

        try {
            const trpzStake = new ethers.Contract(
                configVars.erc20.trpzStake,
                configVars.abi.trpzStake,
                library
            );

            const ownerReward = await getOwnerReward(trpzStake, walletAddress);
            const previewRewards = await getPreviewRewards(trpzStake, walletAddress);

            setClaimableReward(ownerReward + previewRewards);
        } catch (error) {
            console.error("Error:", error);
        }
    }

    async function claimRewards() {
        if (walletAddress === "") return;
        const trpzStake = new ethers.Contract(
            configVars.erc20.trpzStake,
            configVars.abi.trpzStake,
            signer
        );
        try {
            let secondResponse = await trpzStake.connect(signer).updateRewardsAndClaim();
            toast("Reward withdrawal sent! Waiting for the transaction to complete.", {
                className: 'custom-toast'
            });
            await secondResponse.wait();
            toast(
                "Successfully claimed! Your page will be reloaded to reflect the changes", {
                    className: 'custom-toast'
                }
            );
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } catch (error) {
            console.log(error);
            toast(
                "Claim did not work! You may not have exceeded the 24 hour window to claim daily rewards", {
                    className: 'custom-toast'
                }
            );
        }
    }

    function findKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
    }

    async function stakeNFT(nftToStakeContractAddress, tokenId) {
        const stakingContract = configVars.erc20.trpzStake;
        const stakingAbi = configVars.abi.trpzStake;
        const nftToStakeCollection = findKeyByValue(configVars.erc20, nftToStakeContractAddress)
        try {
            let readContract = new ethers.Contract(
                nftToStakeContractAddress,
                configVars.abi[nftToStakeCollection],
                library
            );
            if (
                await readContract.isApprovedForAll(
                    walletAddress,
                    configVars.erc20.trpzStake
                )
            ) {
            } else {
                let writeContract = new ethers.Contract(
                    nftToStakeContractAddress,
                    configVars.abi[nftToStakeCollection],
                    signer
                );
                let response = await writeContract.setApprovalForAll(
                    configVars.erc20.trpzStake,
                    true
                );
                toast("Waiting for approval to confirm before next confirmation. Please do not refresh the page...", {className: 'custom-toast'})
                await response.wait();
            }

        } catch (error) {
            toast(
                "Approval transaction did not work! This will mean an NFT can not be staked.", {
                    className: 'custom-toast'
                }
            );
            console.log(error);
        }
        try {
            const nftContract = new ethers.Contract(stakingContract, stakingAbi, signer);
            let txResponse = await nftContract
                .connect(signer)
                .deposit(
                    walletAddress,
                    nftToStakeContractAddress,
                    tokenId
                );
            toast(
                "Staking transaction sent! This will take a few moments to complete.", {
                    className: 'custom-toast'
                }
            );
            await txResponse.wait();
            toast(
                "Successfully staked! Your page will be reloaded to reflect the changes", {
                    className: 'custom-toast'
                }
            );
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } catch (error) {
            toast(
                "Error: Staking attempt did not work. This may be because you haven't staked 1 OG Troopr to unlock whitelist staking or it may be a connection error.", {
                    className: 'custom-toast'
                }
            );
        }
    }

    async function stakeAll() {
        if (stakedNFTs.length === 0) {
            toast("Please stake one OG Trooper before batch staking", {
                className: 'custom-toast'
            });
            return;
        }
        toast(
            "Maximum of 25 NFTs will be sent to staking per transaction to ensure success. Multiple contract confirmations may be required before final transaction is sent.", {
                className: 'custom-toast'
            }
        );
        let tokenIds = [];
        let contractAddresses = [];
        let nftTotal = 0;
        if (NFTObjects.length > 25) {
            nftTotal = 25;
        } else {
            nftTotal = NFTObjects.length;
        }
        for (let i = 0; i < nftTotal; i++) {
            contractAddresses.push(NFTObjects[i].tokenAddress.toLowerCase());
            tokenIds.push(NFTObjects[i].tokenId);
        }

        let approvedAddresses = [];
        for (let i = 0; i < nftTotal; i++) {
            if (approvedAddresses.includes(NFTObjects[i].tokenAddress.toLowerCase())) {
                continue;
            }
            approvedAddresses.push(NFTObjects[i].tokenAddress.toLowerCase());
            const stakingAddresses = configVars.erc20;
            const abis = configVars.abi;
            let contractName;
            let contractABI;

            for (const [key, value] of Object.entries(stakingAddresses)) {
                if (NFTObjects[i].tokenAddress.toLowerCase() === value) {
                    contractName = key;
                    break;
                }
            }

            for (const [key, value] of Object.entries(abis)) {
                if (key === contractName) {
                    contractABI = value;
                }
            }

            try {
                let readContract = new ethers.Contract(
                    NFTObjects[i].tokenAddress,
                    contractABI,
                    library
                );
                if (
                    await readContract.isApprovedForAll(
                        walletAddress,
                        configVars.erc20.trpzStake
                    )
                ) {
                } else {
                    let writeContract = new ethers.Contract(
                        NFTObjects[i].tokenAddress,
                        contractABI,
                        signer
                    );
                    let response = await writeContract.setApprovalForAll(
                        configVars.erc20.trpzStake,
                        true
                    );
                    toast(
                        "Waiting for approval to confirm before next confirmation. Please do not refresh the page...", {
                            className: 'custom-toast'
                        }
                    );
                    await response.wait();
                }
            } catch (error) {
                toast(
                    "Approval transaction did not work! This will mean an NFT collection may not be batch staked. Please continue then review what did not send.", {
                        className: 'custom-toast'
                    }
                );
                console.log(error);
            }
        }

        try {
            const trpzStake = new ethers.Contract(
                configVars.erc20.trpzStake,
                configVars.abi.trpzStake,
                signer
            );
            let txResponse = await trpzStake
                .connect(signer)
                .batchDeposit(walletAddress, contractAddresses, tokenIds);
            toast(
                "Batch stake transaction sent! This will take a few moments to complete. DO NOT REFRESH", {
                    className: 'custom-toast'
                }
            );
            await txResponse.wait();
            toast(
                "Batch stake successful! Your page will be refreshed and you may need to reconnect your wallet", {
                    className: 'custom-toast'
                }
            );
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } catch (error) {
            toast(
                "The batch send transaction did not work! Please try to do the transaction again.", {
                    className: 'custom-toast'
                }
            );
            console.log(error);
        }
    }

    async function withdrawToken(nftToWithdrawContractAddress, tokenId) {
        const {data, error} = await supabase
            .from('staking_info')
            .select('staker, nft_smart_contract, nft_id')
            .ilike('nft_smart_contract', nftToWithdrawContractAddress.toLowerCase())
            .eq('nft_id', tokenId)
            .ilike('staker', walletAddress.toLowerCase());
        if (error) {
            console.error("Error fetching staked NFTs details: ", error)
            return [];
        }
        try {
            const trpzStake = new ethers.Contract(
                configVars.erc20.trpzStake,
                configVars.abi.trpzStake,
                signer
            );
            let txResponse = await trpzStake.connect(signer).withdraw(walletAddress, data[0].staker, nftToWithdrawContractAddress, tokenId);
            toast(
                "Unstake transaction sent! This will take a few moments to complete.", {
                    className: 'custom-toast'
                }
            );
            await txResponse.wait();
            toast(
                "Successfully unstaked! Your page will be reloaded to reflect the changes.", {
                    className: 'custom-toast'
                }
            );
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } catch (error) {
            toast("Withdraw token transaction did not work! Please try again.", {
                className: 'custom-toast'
            });
            console.log(error);
        }
    }

    async function batchWithdraw() {
        let tokenIds = [];
        let contractAddresses = [];
        let nftTotal = 0;
        if (stakedNFTs.length > 25) {
            nftTotal = 25;
        } else {
            nftTotal = stakedNFTs.length;
        }
        for (let i = 0; i < nftTotal; i++) {
            contractAddresses.push(stakedNFTs[i].tokenAddress.toLowerCase());
            tokenIds.push(stakedNFTs[i].tokenId);
        }
        try {
            const trpzStake = new ethers.Contract(
                configVars.erc20.trpzStake,
                configVars.abi.trpzStake,
                signer
            );
            let txResponse = await trpzStake.connect(signer).batchWithdraw(walletAddress, walletAddress, contractAddresses, tokenIds);
            toast(
                "Batch unstake transaction sent! This will take a few moments to complete.", {
                    className: 'custom-toast'
                }
            );
            await txResponse.wait();
            toast(
                "Successfully batch unstaked! Your page will be reloaded to reflect the changes", {
                    className: 'custom-toast'
                }
            );
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } catch (error) {
            toast("Batch withdraw did not work! Please try again", {
                className: 'custom-toast'
            });
            console.log(error);
        }
    }

    function countOccurrences(arr, valueToCount) {
        let count = 0;

        for (let i = 0; i < arr.length; i++) {
            if (arr[i] === valueToCount) {
                count++;
            }
        }

        return count;
    }

    function countFieldOccurrences(arr, fieldToCheck, valueToCount) {
        let count = 0;

        for (let i = 0; i < arr.length; i++) {
            if (arr[i][fieldToCheck] === valueToCount) {
                count++;
            }
        }

        return count;
    }

    async function selectedBatchWithdraw(nfts) {
        if (!nfts || nfts.length === 0) {
            toast("Please select NFTs for withdrawal.", {
                className: 'custom-toast'
            });
            return;
        }

        let {tokenIds, contractAddresses} = addTokenAddressToContractAddresses(nfts);

        let numberOfTrooprzNftsToWithdraw = countOccurrences(contractAddresses, "0x51112bf32b9a1c64716df2e6b82e63a04bd384fd");
        if (numberOfTrooprzNftsToWithdraw >= 0) {
            let numberOfStakedTrooprzNfts = countFieldOccurrences(stakedNFTs, "tokenAddress", "0x51112bf32b9a1c64716df2e6b82e63a04bd384fd");
            if (numberOfTrooprzNftsToWithdraw >= numberOfStakedTrooprzNfts) {
                toast("You have to keep at least 1 Trooprz NFT staked", {
                    className: 'custom-toast'
                });
            } else {
                try {
                    const trpzStake = new ethers.Contract(
                        configVars.erc20.trpzStake,
                        configVars.abi.trpzStake,
                        signer
                    );

                    let txResponse = await trpzStake.connect(signer).batchWithdraw(walletAddress, walletAddress, contractAddresses, tokenIds);
                    toast(
                        "Batch unstake transaction sent! This will take a few moments to complete. Please do not refresh the page...", {
                            className: 'custom-toast'
                        }
                    );

                    await txResponse.wait();

                    toast(
                        "Batch unstake successful! Your page will be refreshed.", {
                            className: 'custom-toast'
                        }
                    );
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                } catch (error) {
                    toast("Batch unstake did not work! Please try again.", {
                        className: 'custom-toast'
                    });
                    console.log(error);
                }
            }
        }
        }

        async function selectedBatchStake(nfts) {
            if (nfts.length === 0) {
                toast("Please stake one OG Trooper before batch staking", {
                    className: 'custom-toast'
                });
                return;
            }
            toast(
                "Maximum of 25 NFTs will be sent to staking per transaction to ensure success. Multiple contract confirmations may be required before final transaction is sent.", {
                    className: 'custom-toast'
                }
            );
            let tokenIds = [];
            let contractAddresses = [];
            let nftTotal = 0;

            if (nfts.length > 25) {
                nftTotal = 25;
            } else {
                nftTotal = nfts.length;
            }

            for (let i = 0; i < nftTotal; i++) {
                contractAddresses.push(nfts[i].tokenAddress.toLowerCase());
                tokenIds.push(nfts[i].tokenId);
            }

            let approvedAddresses = [];
            for (let i = 0; i < nftTotal; i++) {
                if (approvedAddresses.includes(nfts[i].tokenAddress.toLowerCase())) {
                    continue;
                }
                approvedAddresses.push(nfts[i].tokenAddress.toLowerCase());
                const stakingAddresses = configVars.erc20;
                const abis = configVars.abi;
                let contractName;
                let contractABI;

                for (const [key, value] of Object.entries(stakingAddresses)) {
                    if (nfts[i].tokenAddress.toLowerCase() === value) {
                        contractName = key;
                        break;
                    }
                }

                for (const [key, value] of Object.entries(abis)) {
                    if (key === contractName) {
                        contractABI = value;
                    }
                }

                try {
                    let readContract = new ethers.Contract(
                        nfts[i].tokenAddress,
                        contractABI,
                        library
                    );
                    if (
                        await readContract.isApprovedForAll(
                            walletAddress,
                            configVars.erc20.trpzStake
                        )
                    ) {
                        continue;
                    } else {
                        let writeContract = new ethers.Contract(
                            nfts[i].tokenAddress,
                            contractABI,
                            signer
                        );
                        let response = await writeContract.setApprovalForAll(
                            configVars.erc20.trpzStake,
                            true
                        );
                        toast(
                            "Waiting for approval to confirm before next confirmation. Please do not refresh the page...", {
                                className: 'custom-toast'
                            }
                        );
                        await response.wait();
                    }
                } catch (error) {
                    toast(
                        "Approval transaction did not work! This will mean an NFT collection may not be batch staked. Please continue then review what did not send.", {
                            className: 'custom-toast'
                        }
                    );
                    console.log(error);
                }
            }
            try {
                const trpzStake = new ethers.Contract(
                    configVars.erc20.trpzStake,
                    configVars.abi.trpzStake,
                    signer
                );
                let txResponse = await trpzStake
                    .connect(signer)
                    .batchDeposit(walletAddress, contractAddresses, tokenIds);
                toast(
                    "Batch stake transaction sent! This will take a few moments to complete. DO NOT REFRESH", {
                        className: 'custom-toast'
                    }
                );
                await txResponse.wait();
                toast(
                    "Batch stake successful! Your page will be refreshed and you may need to reconnect your wallet", {
                        className: 'custom-toast'
                    }
                );
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            } catch (error) {
                toast(
                    "The batch send transaction did not work! Please try to do the transaction again.", {
                        className: 'custom-toast'
                    }
                );
                console.log(error);
            }
        }

        return (
            <div className="App">
                <Header
                    setAddress={setAddress}
                    walletAddress={walletAddress}
                    availableNFTs={availableNFTs}
                    setAvailableNFTs={setAvailableNFTs}
                    signer={signer}
                    setSigner={setSigner}
                    connectWallet={connectWallet}
                    disconnectWallet={disconnectWallet}
                />
                <StakeBanner trpzBalance={trpzBalance}/>
                <StakeHeader
                    claimableReward={claimableReward}
                    claimRewards={claimRewards}
                />
                <StakeStats
                    availableNFTs={availableNFTs}
                    stakedNFTCount={stakedNFTCount}
                    totalReward={totalReward}
                    claimableReward={claimableReward}
                />
                {loading ? (
                    <ClipLoader color={"#F58800"} loading={loading} size={150}/>
                ) : (
                    <StakeBody
                        stakedNFTs={stakedNFTs}
                        NFTObjects={NFTObjects}
                        allNFTs={allNFTs}
                        stakeNFT={stakeNFT}
                        stakeAll={stakeAll}
                        withdrawToken={withdrawToken}
                        batchWithdraw={batchWithdraw}
                        selectedBatchStake={selectedBatchStake}
                        selectedBatchUnstake={selectedBatchWithdraw}
                        disabled={disabled}
                    />
                )}
                <Footer/>
            </div>
        );
    }

    export default App;
